import ScrollSider from "common/utils/ui/scroll-slider";

export default function initHeroCardsScroll() {
  new ScrollSider({
    arrow: ".js-hero-cards-arrow",
    content: ".js-hero-cards-content",
    slider: ".js-hero-cards-slider",
    scrollDistance: 600,
    hideOnDisable: true
  }).init();
}
